export enum Action {
  UPDATE_STEP = "UPDATE_STEP",
  SET_ACTIVE_VIEW = "SET_ACTIVE_VIEW",
  UPDATE_PURCHASE_ORDER = "UPDATE_PURCHASE_ORDER",
  UPDATE_COUPON_APPLY_APPLICABLE_RATE = "UPDATE_COUPON_APPLY_APPLICABLE_RATE"
}
